// 有效期统一往后延：起始年 +3 年，结束年 +5 年
const START_YEAR_OFFSET = 3
const END_YEAR_OFFSET = 5

// 起止日期：4 位年份 + 可选的月、日（9 位 2020/1/01、10 位 2020/01/01 都能匹配）
const DATE_PATTERN = '\\d{4}\\D?\\d{1,2}\\D?\\d{1,2}'
// 中间的连接符支持 — – ~ ～ 至 到 -
const RANGE_PATTERN = new RegExp('^(\\s*)(' + DATE_PATTERN + ')\\s*[-—–~～至到]+\\s*(' + DATE_PATTERN + ')([\\s\\S]*)$')

// 只替换日期里的年份，月、日和补零写法原样保留
function shiftYear (date, offset) {
  return date.replace(/\d{4}/, (year) => String(Number(year) + offset))
}

export function parseDate (time) {
  if (time === null || time === undefined || time === '') {
    return ''
  }
  const text = String(time)
  const matched = text.match(RANGE_PATTERN)
  if (matched) {
    // 起止日期之间统一用「空格 + — + 空格」连接
    return matched[1] + shiftYear(matched[2], START_YEAR_OFFSET) + ' — ' + shiftYear(matched[3], END_YEAR_OFFSET) + matched[4]
  }
  // 兜底：不按日期格式解析，只把整串里第 1、2 个 4 位年份当作起始年、结束年
  let index = 0
  const result = text.replace(/\d{4}/g, (year) => {
    index += 1
    if (index === 1) {
      return String(Number(year) + START_YEAR_OFFSET)
    }
    if (index === 2) {
      return String(Number(year) + END_YEAR_OFFSET)
    }
    return year
  })
  // 连两个年份都解析不出来（空值、单个日期等）时原样返回，避免脏数据被算坏
  return index >= 2 ? result : text
}



// WEBPACK FOOTER //
// ./src/utils/parseDate.js